import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as R from 'ramda'

import VerticalTableInput from 'components/form/verticalTableInput/index'
import { createNamedReducer } from 'helpers/ReducerUtil'
import { createNamedAction } from 'helpers/ActionUtil'
import verticalTableInputReducer from './reducer'
import injectReducer from 'helpers/injectReducer'
import getSelectors from './selectors'
import { getElementKeySelector, getRowFormatSelector } from './selectors'
import { elementsSelector } from 'helpers/ComponentSelectorUtil'

import {
  addValue,
  updateValue,
  removeValue,
} from './actions'
import {
  getPath,
  combinePath
} from 'containers/Form/util'

const withReducer = (path, id) => {
  const valuePath = getPath(path, id)
  const reducer = createNamedReducer(valuePath, verticalTableInputReducer)
  return injectReducer(valuePath, reducer)
}

const withConnect = (path, id) => {
  const combinedPath = combinePath(path, id)
  const valuePath = getPath(path, id)

  const {
    valuesSelector,
    labelSelector,
    hintSelector
  } = getSelectors(combinedPath)

  const updateValueAction = createNamedAction(valuePath, updateValue)
  const removeValueAction = createNamedAction(valuePath, removeValue)
  const addValueAction = createNamedAction(valuePath, addValue)

  const mapStateToProps = (state) => {
    return {
      title: labelSelector(state),
      values: valuesSelector(state),
      hint: hintSelector(state),
      rowFormat: getRowFormatSelector(id)(state),
      elementKey: getElementKeySelector(id)(state)
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      onChange: (index, type, value) => dispatch(updateValueAction(index, type, value)),
      onRemove: (index) => dispatch(removeValueAction(index)),
      onAdd: () => dispatch(addValueAction()),
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)
}

export { UPDATE_VALUE } from './constants'
export { getValuesSelector } from './selectors'
export { default as VerticalTableInput } from 'components/form/verticalTableInput/index'
export {
  withConnect,
  withReducer
}

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
  withConnect(path, id)
)(VerticalTableInput))
